// extracted by mini-css-extract-plugin
export default {"loyaltyIcon":"LoyaltyIcon_loyaltyIcon__KJtZH"};